import React from 'react';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Courses from '../components/Courses';
import WhyChoose from '../components/WhyChoose';
import TechStack from '../components/TechStack';

function Home() {
  return (
    <>
      <Hero />
      <Features />
      <Courses />
      <WhyChoose />
      <TechStack />
    </>
  );
}

export default Home;
